export const SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
}

export const CONTROL_SIZES = {
    [SIZES.XS]: 7,
    [SIZES.SM]: 9,
    [SIZES.MD]: 11,
    [SIZES.LG]: 14,
    [SIZES.XL]: 16,
}

export const LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
}

export const DIRECTIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
}

export const SELECTION_MODES = {
    YEAR: 'year',
    MONTH: 'month',
    DAY: 'day',
}

export const PICKER_VIEWS = {
    YEAR: 'year',
    MONTH: 'month',
    DATE: 'date',
}

export const STATUS = {
    DANGER: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning',
}

export const STEPS_STATUS = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    ERROR: 'error',
}

export const PLACEMENT = {
    TOP_START: 'top-start',
    TOP_CENTER: 'top-center',
    TOP_END: 'top-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_END: 'bottom-end',
    MIDDLE_START_TOP: 'middle-start-top',
    MIDDLE_START_BOTTOM: 'middle-start-bottom',
    MIDDLE_END_TOP: 'middle-end-top',
    MIDDLE_END_BOTTOM: 'middle-end-bottom',
    CENTER_CENTER: 'center-center'
}

export const DROPDOWN_ITEM_TYPE = {
    DEFAULT: 'default',
    HEADER: 'header',
    DIVIDER: 'divider',
    CUSTOM: 'custom',
}

export const DAY_DURATION = 86400000

export const PHP_INT_MAX = 9223372036854775807

export const PUBLIC_URL = process.env.REACT_APP_BASE_URL

export const PRIMARY_FOLLOWR_DOMAINS = ['followr.ai', 'followr.studio', 'localhost'];

export const isPrimaryFollowrHostname = (hostname) => {
  if (!hostname) return false;
  const host = String(hostname).toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0];
  return PRIMARY_FOLLOWR_DOMAINS.some(
    (domain) => host === domain || host.endsWith(`.${domain}`)
  );
};

export const isFollowrStudioHostname = (hostname) => {
  if (!hostname) return false;
  const host = String(hostname).toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0];
  return host === 'followr.studio' || host.endsWith('.followr.studio') || host.includes("localhost");
};

export const POLOTNO_API_KEY = process.env.REACT_APP_POLOTNO_API_KEY;

export const YOUTUBE_ENABLED = process.env.REACT_APP_YOUTUBE_ENABLED === "1";

export const THREADS_ENABLED = process.env.REACT_APP_THREADS_ENABLED === "1";

export const CANVA_ENABLED = process.env.REACT_APP_CANVA_ENABLED === "1";

export const BLUESKY_ENABLED = process.env.REACT_APP_BLUESKY_ENABLED === "1";

export const CONTACTS_ENABLED = process.env.REACT_APP_CONTACTS_ENABLED === "1";

export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;

export const FREE_TRIAL_DAYS = parseInt(process.env.REACT_APP_FREE_TRIAL_DAYS);

export const TRIAL_PRICE_CENTS = parseInt(process.env.REACT_APP_TRIAL_PRICE_CENTS || "0");

// Trial mode helpers. Both flags require FREE_TRIAL_DAYS > 0; the price flag
// then decides whether it's a free or paid (verification-fee) trial.
export const HAS_PAID_TRIAL = FREE_TRIAL_DAYS > 0 && TRIAL_PRICE_CENTS > 0;
export const HAS_FREE_TRIAL = FREE_TRIAL_DAYS > 0 && TRIAL_PRICE_CENTS === 0;

// Display helper — assumes USD (the only currency our plans use today).
// If multi-currency lands, replace with the value from /public/trial-config.
export const TRIAL_PRICE_DISPLAY = TRIAL_PRICE_CENTS > 0
    ? `$${(TRIAL_PRICE_CENTS / 100).toFixed(TRIAL_PRICE_CENTS % 100 === 0 ? 0 : 2)}`
    : '';

export const REQUIRE_PAYMENT = process.env.REACT_APP_REQUIRE_PAYMENT === "1";

export const COMPANY_ONBOARDING_REQUIRED = process.env.REACT_APP_COMPANY_ONBOARDING_REQUIRED === "1";

export const AI_IMAGE_EDIT_ENABLED = process.env.REACT_APP_AI_IMAGE_EDIT_ENABLED === "1";

// AppSumo — Codes campaign (stackable lifetime codes / sumoling tier)
export const APPSUMO_CODES_ENABLED    = process.env.REACT_APP_APPSUMO_CODES_ENABLED === "1";
export const APPSUMO_CODES_URL        = process.env.REACT_APP_APPSUMO_CODES_URL || "https://appsumo.com/products/followr-may-2026-ver-4-0/?p=1";
export const APPSUMO_CODES_START_DATE = process.env.REACT_APP_APPSUMO_CODES_START_DATE || "";
export const APPSUMO_CODES_END_DATE   = process.env.REACT_APP_APPSUMO_CODES_END_DATE || "";

// AppSumo — Studio (license) campaign (tiered lifetime license)
export const APPSUMO_STUDIO_ENABLED    = process.env.REACT_APP_APPSUMO_STUDIO_ENABLED === "1";
export const APPSUMO_STUDIO_URL        = process.env.REACT_APP_APPSUMO_STUDIO_URL || "https://appsumo.com/products/followr-studio/?p=1";
export const APPSUMO_STUDIO_START_DATE = process.env.REACT_APP_APPSUMO_STUDIO_START_DATE || "";
export const APPSUMO_STUDIO_END_DATE   = process.env.REACT_APP_APPSUMO_STUDIO_END_DATE || "";

export const APPSUMO_MAX_TIER         = parseInt(process.env.REACT_APP_APPSUMO_MAX_TIER || "10");
// Mirrors config/subscription.php license_plans length (3 tiers).
export const APPSUMO_MAX_LICENSE_TIER = 3;

const isWithinAppSumoWindow = (start, end) => {
    const now = Date.now();
    if (start) {
        const startMs = new Date(`${start}T00:00:00`).getTime();
        if (Number.isFinite(startMs) && now < startMs) return false;
    }
    if (end) {
        const endMs = new Date(`${end}T23:59:59.999`).getTime();
        if (Number.isFinite(endMs) && now > endMs) return false;
    }
    return true;
};

export const isAppSumoCodesCampaignLive  = () => APPSUMO_CODES_ENABLED  && isWithinAppSumoWindow(APPSUMO_CODES_START_DATE,  APPSUMO_CODES_END_DATE);
export const isAppSumoStudioCampaignLive = () => APPSUMO_STUDIO_ENABLED && isWithinAppSumoWindow(APPSUMO_STUDIO_START_DATE, APPSUMO_STUDIO_END_DATE);
export const isAnyAppSumoCampaignLive    = () => isAppSumoCodesCampaignLive() || isAppSumoStudioCampaignLive();

export const APPSUMO_ADDON_ENABLED = process.env.REACT_APP_APPSUMO_ADDON_ENABLED === "1";

export const APPSUMO_ADDON_URL = process.env.REACT_APP_APPSUMO_ADDON_URL || "";

export const HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION = process.env.REACT_APP_HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION || "";

export const NETLIFY_CNAME = process.env.REACT_APP_NETLIFY_CNAME || "apex-loadbalancer.netlify.com";

export const NETLIFY_A_RECORD = process.env.REACT_APP_NETLIFY_A_RECORD || "75.2.60.5";

export const AI_AVATARS_ENABLED = process.env.REACT_APP_AI_AVATARS_ENABLED === "1";

export const AI_VOICES_ENABLED = process.env.REACT_APP_AI_VOICES_ENABLED === "1";

export const CREATOMATE_PUBLIC_TOKEN = process.env.REACT_APP_CREATOMATE_PUBLIC_TOKEN || "public-q9wk6bex585yf2gqf1vuvgg6";

export const AVATAR_VIDEO_MODEL = process.env.REACT_APP_AVATAR_VIDEO_MODEL || "veed_fabric_1.0";
export const AVATAR_VIDEO_MODEL_FAST = process.env.REACT_APP_AVATAR_VIDEO_MODEL_FAST || "veed_fabric_1.0_fast";

export const AI_CREATIVE_STUDIO_ENABLED = process.env.REACT_APP_AI_CREATIVE_STUDIO_ENABLED === "1";

// Two-pane post composer (form + readonly preview) shown instead of the
// classic fullscreen mimic-card editor. Off ⇒ legacy editor, byte-identical.
export const POST_COMPOSER_ENABLED = process.env.REACT_APP_POST_COMPOSER_ENABLED === "1";

export const AI_STUDIO_BLOCKED_PLANS = ["free", "pro"];